import { createSelector } from '@reduxjs/toolkit';
import { EDecorationType } from '../../../../packages/JsonQuery';
import { selectDecorationsList } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Чистовая с мебелью', value: EDecorationType.FineWithFurniture },
  { label: 'Чистовая', value: EDecorationType.Fine },
  { label: 'Предчистовая', value: EDecorationType.PreFine },
  { label: 'Без отделки', value: EDecorationType.Without },
];

export const selectDecorationsListFilter = createSelector(selectDecorationsList, value => ({
  label: 'Отделка',
  value: value?.length ? (value as EDecorationType[]) : [null],
  options: OPTIONS,
}));
